<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      label-width="80px"
    >
      <el-form-item
        label="系列预算"
        prop="budgetAmount"
      >
        <el-input
          v-model="formData.budgetAmount"
          v-to-fixed="2"
          style="width: 320px"
          type="number"
          placeholder="请输入预算金额"
          @change="emitMsg"
        >
          <el-select
            v-model="formData.budgetType"
            @change="emitMsg"
            placeholder=""
            slot="prepend"
            style="width: 120px"
          >
            <el-option
              v-for="item in enumConstants.budgetTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span slot="append">{{ currency }}</span>
        </el-input>
      </el-form-item>
      <div class="flex">
        <el-form-item
          label="排期"
          prop="startDate"
        >
          <el-date-picker
            v-model="formData.startDate"
            @change="emitMsg"
            type="datetime"
            placeholder="开始时间"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <span class="mx-2">~</span>
        <el-form-item
          label=""
          label-width="0"
          prop="endDate"
        >
          <el-date-picker
            v-model="formData.endDate"
            @change="emitMsg"
            type="datetime"
            placeholder="结束时间"
            :picker-options="pickerOptions1"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </div>
      <el-form-item label="竞价策略">
        <el-radio-group
          v-model="bidStrategyType"
          @change="handleBidStrategyTypeChange"
        >
          <el-radio
            v-for="item in enumConstants.bidStrategy"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <!-- 显示设置出价复选框 -->
      <el-form-item label="">
        <el-checkbox
          v-model="setBidValue"
          @change="handleSetBidValueChange"
          >{{ checkboxLabel }}</el-checkbox
        >
      </el-form-item>
      <el-form-item
        v-if="setBidValue"
        label=""
        prop="bidAmount"
      >
        <el-input
          v-model="formData.bidAmount"
          v-to-fixed="2"
          :placeholder="bidStrategyType === 'MAX_CONVERSION' ? '请输入出价金额' : '请输入转化价值'"
          style="width: 240px"
          type="number"
          @change="emitMsg"
        >
          <span slot="append">
            <span v-if="bidStrategyType === 'MAX_CONVERSION'">{{ currency }}/转化</span>
            <span v-else>%</span>
          </span>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'CampaignBudget',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    currentAccount: {
      type: Object,
      default: () => ({}),
    },
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 本地状态：界面 radio 选择（MAX_CONVERSION / TARGET_CPA / TARGET_ROAS）
      bidStrategyType: 'MAX_CONVERSION',
      // 本地状态：复选框是否勾选（仅目标出价/转化价值时使用）
      setBidValue: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerOptions1: {
        disabledDate: this.disabledDate,
      },
      checkData: {
        adsetBudgetMin: 5,
        adsetBudgetMax: 10000000,
        bidMin: 0.01,
        bidMax: 1000000,
        roasBidMin: 0.01,
        roasBidMax: 1000,
      },
    };
  },
  computed: {
    currency() {
      return this.currentAccount.currency || 'USD';
    },
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    // 复选框文案
    checkboxLabel() {
      return this.bidStrategyType === 'MAX_CONVERSION' ? '设置目标每次转化费用' : '设置目标 ROAS';
    },
    rules() {
      return {
        budgetAmount: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback('预算不能为空');
              if (this.formData.budgetType == 'LIFE_TIME') {
                if (this.formData.startDate && this.formData.endDate && value < this.getBudgetMin()) {
                  return callback(`预算在${this.getBudgetMin()}～${this.checkData.adsetBudgetMax}区间`);
                }
              } else if (value && (value < this.checkData.adsetBudgetMin || value > this.checkData.adsetBudgetMax)) {
                return callback(`预算在${this.checkData.adsetBudgetMin}～${this.checkData.adsetBudgetMax}区间`);
              }
              callback();
            },
            required: true,
            trigger: ['blur', 'change'],
          },
        ],
        startDate: [{ required: true, message: '请选择开始时间', trigger: ['change', 'blur'] }],
        endDate: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.budgetType == 'LIFE_TIME') {
                if (!value) {
                  callback('预算类型是总预算的时候,结束时间必填');
                }
                if (new Date(value).getTime() < new Date(this.formData.startDate).getTime()) {
                  return callback('结束时间不能小于开始时间');
                }
              }
              callback();
            },
            trigger: ['blur', 'change'],
          },
        ],
        bidAmount: [
          {
            validator: (rule, value, callback) => {
              // 不勾选复选框时不参与校验
              if (!this.setBidValue) {
                callback();
                return;
              }
              const isRoas = this.bidStrategyType === 'MAX_CONVERSION_VALUE';
              const min = isRoas ? this.checkData.roasBidMin : this.checkData.bidMin;
              const max = isRoas ? this.checkData.roasBidMax : this.checkData.bidMax;
              // 目标出价勾选后必须填值；转化价值勾选后可填可不填
              if (!isRoas && (!value && value !== 0)) {
                return callback('请输入出价金额');
              }
              // 如果有填值，校验区间
              if (value && value !== 0) {
                if (value < min || value > max) {
                  return callback(isRoas ? `转化价值在${min}～${max}区间` : `出价在${min}～${max}区间`);
                }
              }
              callback();
            },
            trigger: ['blur', 'change'],
          },
        ],
      };
    },
  },
  watch: {
    // 监听外部传入的 value 变化（暂存恢复/编辑回填），反向回显本地状态
    'value.bidStrategy': {
      handler(val) {
        if (val) {
          this.reverseBidStrategy(val);
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 反向回显：由真实 bidStrategy 反推本地状态
    reverseBidStrategy(bidStrategy) {
      switch (bidStrategy) {
        case 'TARGET_CPA':
          this.bidStrategyType = 'MAX_CONVERSION';
          this.setBidValue = true;
          break;
        case 'MAX_CONVERSION':
          // 目标出价不设值
          this.bidStrategyType = 'MAX_CONVERSION';
          this.setBidValue = false;
          break;
        case 'TARGET_ROAS':
          this.bidStrategyType = 'MAX_CONVERSION_VALUE';
          this.setBidValue = true;
          break;
        case 'MAX_CONVERSION_VALUE':
          // 转化价值不设值
          this.bidStrategyType = 'MAX_CONVERSION_VALUE';
          this.setBidValue = false;
          break;
        default:
          // 兼容旧数据，默认目标出价
          this.bidStrategyType = 'MAX_CONVERSION';
          this.setBidValue = false;
          break;
      }
    },
    // 正向计算：根据本地状态计算真实的 bidStrategy
    calcRealBidStrategy() {
      if (this.bidStrategyType === 'MAX_CONVERSION') {
        return this.setBidValue && this.formData.bidAmount > 0 ? 'TARGET_CPA' : 'MAX_CONVERSION';
      }
      // MAX_CONVERSION_VALUE
      return this.setBidValue && this.formData.bidAmount > 0 ? 'TARGET_ROAS' : 'MAX_CONVERSION_VALUE';
    },
    // 根据结束日期，计算最小预算
    getBudgetMin() {
      let start = moment(this.formData.startDate).format('YYYY-MM-DD');
      let end = moment(this.formData.endDate).format('YYYY-MM-DD');
      let days = moment(end).diff(start, 'days');
      return this.checkData.adsetBudgetMin * (days + 1);
    },
    disabledDate(time) {
      return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.formData.startDate).getTime();
    },
    // 对外提供的验证
    validate() {
      return this.$refs.form.validate();
    },
    // 导出数据（正向映射后 emit）
    emitMsg() {
      this.formData.budgetAmount = Number(this.formData.budgetAmount).toFixed(2);
      // 正向计算真实 bidStrategy
      const realBidStrategy = this.calcRealBidStrategy();
      this.formData.bidStrategy = realBidStrategy;
      // 不勾选或无值时置 null，勾选且有值时保留出价值
      if (!this.setBidValue || !this.formData.bidAmount) {
        this.formData.bidAmount = null;
      } else {
        this.formData.bidAmount = Number(this.formData.bidAmount).toFixed(2);
      }
      this.$emit('change', { ...this.value, ...this.formData });
      this.$emit('input', { ...this.value, ...this.formData });
    },
    // 切换竞价策略类型时：重置复选框和出价值，清除校验
    handleBidStrategyTypeChange() {
      this.setBidValue = false;
      this.formData.bidAmount = null;
      this.$nextTick(() => {
        this.$refs.form.clearValidate('bidAmount');
      });
      this.emitMsg();
    },
    // 复选框变化时
    handleSetBidValueChange(val) {
      if (!val) {
        this.formData.bidAmount = null;
        this.$nextTick(() => {
          this.$refs.form.clearValidate('bidAmount');
        });
      }
      this.emitMsg();
    },
  },
};
</script>
<style lang="scss" scoped></style>
